export default {
  progress: require('./sounds/progress.wav'),
  ring: require('./sounds/ring.wav'),
};
